import React from "react";
import { Box, Typography } from "@mui/material";
import KBLogo from "../../assets/logo/KBLogo.svg";
import CompanySetupCard from "../../Components/CompanySetupCard/CompanySetupCard";
import LaunchIcon from "@mui/icons-material/Launch";

function Insurance({ onContinue, onBack }) {
  const handleOpenAccount = () => {
    localStorage.setItem(
      "activeFormCompanySetup",
      "isInsuranceDetailCompleted"
    );
    onContinue();
  };

  return (
    <Box sx={{ p: 3, width: "100%", bgcolor: "#fff" }}>
      {/* Header Section */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h6" fontWeight="bold">
          Set up your Business Bank Account in just a few clicks
        </Typography>
      </Box>

      {/* Description Text */}
      <Typography
        variant="body1"
        color="text.primary"
        sx={{ mb: 3, fontWeight: "450" }}
      >
        We've partnered with some of the UK's leading Business Banks to
        streamline the process and get you access to the best discounts
        available.
      </Typography>

      {/* Partner Card */}
      <CompanySetupCard
        id={"Kingsbridge"}
        logo={KBLogo}
        title="Kingsbridge Insurance"
        offer={"Offer: 10% Discount every year" || ""}
        body={
          <>
            {" "}
            We've partnered with some of the UK's leading Business Banks to
            streamline the process and get you access to the best discounts
            available.
          </>
        }
        icon={LaunchIcon}
        applicationUrl={"https://risegroup.kingsbridge.co.uk/"}
        buttonText={"Get Quote"}
        handleOpenAccount={handleOpenAccount}
      />
    </Box>
  );
}

export default Insurance;
